module.exports = __webpack_public_path__ + "img/home-icon-int-green.b3115202.svg";